// Shared field definitions for the notary profile.
// Used by useNotaryDrawerData (the uuid-driven notary drawer).

export const PROFILE_FIELDS = [
  "previous_full_name",
  "documents",
  "notarial_actions_codes",
  "education_institution",
  "education_graduation_date",
  "education_specialty",
  "education_diploma_number",
  "education_diploma_issue_date",
  "work_schedule",
  "work_phone",
  "access_allowed",
  "chamber_join_date",
  "registration_date",
  "status",
  "exclusion_date",
  "payment_start_date",
  "payment_end_date",
  "place_of_birth_id",
  "office_address_id",
  "residential_address_id",
  "insurance_company_name",
  "insurance_contract_end_date",
  "license_number",
  "license_issue_date",
  "license_status",
  "license_status_reason",
  "license_status_start_date",
  "license_history",
  "block_description",
  "block_start_date",
  "block_end_date",
  "bank_name",
  "bank_name_kz",
  "iik",
  "bik",
  "kbe",
];

export const USER_FIELDS = [
  "identifier",
  "email",
  "phone",
  "first_name",
  "last_name",
  "middle_name",
  "is_active",
  "organization_id",
  "role_codes",
];

export const DATE_FIELDS = new Set([
  "education_graduation_date",
  "education_diploma_issue_date",
  "chamber_join_date",
  "registration_date",
  "exclusion_date",
  "payment_start_date",
  "payment_end_date",
  "insurance_contract_end_date",
  "license_issue_date",
  "license_status_start_date",
  "block_start_date",
  "block_end_date",
]);

export const SKIP_IF_EMPTY = new Set([
  ...DATE_FIELDS,
  "previous_full_name",
  "education_institution",
  "education_specialty",
  "education_diploma_number",
  "work_schedule",
  "work_phone",
  "status",
  "insurance_company_name",
  "license_number",
  "license_status",
  "license_status_reason",
  "block_description",
  "bank_name",
  "bank_name_kz",
  "iik",
  "bik",
]);

export function clone(v) {
  return JSON.parse(JSON.stringify(v ?? {}));
}

export function pickFields(data, fields) {
  const out = {};
  for (const k of fields) {
    const v = data[k];
    if (v === undefined) continue;
    if (v === "" || v === null) {
      if (SKIP_IF_EMPTY.has(k)) continue;
      out[k] = null;
      continue;
    }
    out[k] = v;
  }
  return out;
}

export function emptyData() {
  return {
    identifier: "",
    email: "",
    phone: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    is_active: true,
    organization_id: null,
    role_codes: [],

    previous_full_name: "",
    documents: [],
    notarial_actions_codes: [],
    education_institution: "",
    education_graduation_date: "",
    education_specialty: "",
    education_diploma_number: "",
    education_diploma_issue_date: "",
    work_schedule: "",
    work_phone: "",
    access_allowed: true,
    chamber_join_date: "",
    registration_date: "",
    status: "",
    exclusion_date: "",
    payment_start_date: "",
    payment_end_date: "",
    place_of_birth_id: null,
    office_address_id: null,
    residential_address_id: null,
    insurance_company_name: "",
    insurance_contract_end_date: "",
    license_number: "",
    license_issue_date: "",
    license_status: "",
    license_status_reason: "",
    license_status_start_date: "",
    license_history: [],
    block_description: "",
    block_start_date: "",
    block_end_date: "",
    bank_name: "",
    bank_name_kz: "",
    iik: "",
    bik: "",
    kbe: null,
  };
}
